import type { ScreenSchema } from './types';
const passwordMeterSchema: ScreenSchema = {
  template: 'password-meter',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
  }
};
export default passwordMeterSchema;
